// extracted by mini-css-extract-plugin
export default {"buttonGroup":"ModalVerifyArtist_buttonGroup__3N4Qz","verifyIcon":"ModalVerifyArtist_verifyIcon__4bdG2","select":"ModalVerifyArtist_select__B3B1Q"};